<template lang="pug">
    div(:class="{'form-container': getType($route.query.slug) !== 'Presentations', 'neuro-games__container': isBonusGames}")
        div(v-if='!areSchoolsBlocked' :class="{'form-container__box': getType($route.query.slug) !== 'Presentations'}")
            cs-loader(v-if='isLoading')
            div(
                v-else,
                :is='getType($route.query.slug)',
                :game-mode='gameMode',
                :course-type='$route.params.gamesType',
                :slug='$route.query.slug',
                :id='id',
                :game-id='gameId',
                :players-number='playersNumber',
                :current-player='currentPlayer',
                @playersNumber='playersNumber = arguments[0]',
                :names-array="namesArray",
                :same-settings-are-active="sameSettingsAreActive",
                @sameSettings="sameSettings = $event",
            )
                template(v-if="doesGameAllowMultiplayer")
                    template(slot='multiplayer', v-if="$offline || (user.type !== 'student' && gameMode === 'free-game')")
                        .form-container__field
                            label.form-container__label
                                | {{ $i18n.t('trainer.trainer_gameFormSetting_numOfPlayers') }}
                            .form-container__select
                                cs-spin-input(
                                    :value="playersNumber",
                                    :min="1",
                                    :max="8",
                                    @increase="playersNumber++",
                                    @decrease="playersNumber--",
                                    @input="playersNumber = $event"
                                )
                        .form-container__field.checkbox-field(v-if="playersNumber > 1")
                            label.form-container__label.checkbox-label
                                |  {{ $i18n.t('trainer.trainer_gameFormSetting_sameSettingsForEveryone') }}
                            cs-checkbox.form-container__checkbox(
                                :checked="sameSettings"
                                @change="sameSettingsAreActive = !sameSettingsAreActive"
                            )
                        form-tabs(
                            v-if="playersNumber > 1",
                            elements-type="player"
                            :tabs-number="playersNumber",
                            :same-settings-are-active="sameSettingsAreActive",
                            @setNamesArray="newNames => namesArray = newNames",
                            @setCurrentTab="num => currentPlayer = num"
                        )
                        divider.form-container__player-block-divider_before-game-setting(v-else)
                template(slot='title')
                    template(v-if="gameMode === 'course' || $route.query.slug === 'MultiplicationAndDivisionCourse'")
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_courseGameTitle') }}
                    template(v-else-if="gameMode === 'free-game'")
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_freeGameTitle') }}
                    template(v-else) {{ getGameName({slug: $route.query.slug}) }}
                .help-block(slot='help', v-if="gameMode === 'free-game'")
                    | {{ $route.params.gamesType === 'mentalArithmetic' ? $i18n.t('common.common_helpText_notAvailableOptions') : '' }}
        box(v-else)
            div
                | {{ $i18n.t('common.common_textInfo_pageNotAllowed') }}
</template>

<script>
    import { checkUserRouteAccess } from '@/utils/tariffHelper';

    const AdditionAndSubtraction = () => import('../games/games-forms/AddSubForm.vue');
    const FlashCards = () => import('../games/games-forms/FlashCardsForm.vue');
    const MultiplicationAndDivision = () => import('../games/games-forms/MultiplicationAndDivisionForm.vue');
    const MultiplicationAndDivisionCourse = () =>
        import('../games/games-forms/MultiplicationAndDivisionFormForCourses.vue');
    const Equation = () => import('../games/games-forms/EquationForm.vue');
    const Factorization = () => import('../games/games-forms/FactorizationForm.vue');
    const EquationMultiplication = () => import('../games/games-forms/EquationMultiplicationForm.vue');
    const EquationOnline = () => import('../games/games-forms/EquationOnlineForm.vue');
    const Anzan = () => import('../games/games-forms/AnzanForm.vue');
    const Puzzle = () => import('../games/games-forms/PuzzleForm.vue');
    const Couples = () => import('../games/games-forms/CouplesForm.vue');
    const Chains = () => import('../games/games-forms/ChainsForm.vue');
    const Schulte = () => import('../games/games-forms/SchulteForm.vue');
    const Scanner = () => import('../games/games-forms/ScannerForm.vue');
    const WordsField = () => import('../games/games-forms/WordsFieldForm.vue');
    const WordsFieldReadingEn = () => import('../games/games-forms/WordsFieldReadingEnForm.vue');
    const Shutter = () => import('../games/games-forms/ShutterForm.vue');
    const ShutterReadingEn = () => import('../games/games-forms/ShutterReadingEnForm.vue');
    const ShutterRussianLanguage = () => import('../games/games-forms/ShutterRussianLanguageForm.vue');
    const Anagrams = () => import('../games/games-forms/AnagramsForm.vue');
    const Texts = () => import('../games/games-forms/TextsForm.vue');
    const LettersField = () => import('../games/games-forms/LettersFieldForm.vue');
    const CatchWord = () => import('../games/games-forms/CatchWordForm.vue');
    const CatchWordReadingEn = () => import('../games/games-forms/CatchWordReadingEnForm.vue');
    const VisionField = () => import('../games/games-forms/VisionFieldForm.vue');
    const VisionFieldReadingEn = () => import('../games/games-forms/VisionFieldReadingEnForm.vue');
    const Navigator = () => import('../games/games-forms/NavigatorForm.vue');
    const NavigatorBonusGames = () => import('../games/games-forms/NavigatorForm.vue');
    const Matrix = () => import('../games/games-forms/MatrixForm.vue');
    const Memorize = () => import('../games/games-forms/MemorizeForm.vue');
    const KeenEye = () => import('../games/games-forms/KeenEyeForm.vue');
    const KeenEyeBonusGames = () => import('../games/games-forms/KeenEyeForm.vue');
    const NumericalNetwork = () => import('../games/games-forms/NumericalNetworkForm.vue');
    const Synonyms = () => import('../games/games-forms/SynonymsForm.vue');
    const SynonymsReadingEn = () => import('../games/games-forms/SynonymsReadingEnForm.vue');
    const SynonymsRussianLanguage = () => import('../games/games-forms/SynonymsRussianLanguageForm.vue');
    const AntonymsRussianLanguage = () => import('../games/games-forms/AntonymsRussianLanguageForm.vue');
    const Antonyms = () => import('../games/games-forms/AntonymsForm.vue');
    const Search = () => import('../games/games-forms/SearchForm.vue');
    const Classifications = () => import('../games/games-forms/ClassificationsForm.vue');
    const SoundCouples = () => import('../games/games-forms/SoundCouplesForm.vue');
    const DigitCouples = () => import('../games/games-forms/DigitCouplesForm.vue');
    const FourthOne = () => import('../games/games-forms/FourthOneForm.vue');
    const Memory = () => import('../games/games-forms/MemoryForm.vue');
    const Presentations = () => import('../games/games-forms/PresentationsForm.vue');
    const RootsAndDegrees = () => import('../games/games-forms/RootsAndDegreesForm');
    const Expressions = () => import('../games/games-forms/ExpressionsForm.vue');
    const DayOfWeek = () => import('../games/games-forms/DayOfWeekForm.vue');
    const RootsAndSquares = () => import('../games/games-forms/RootsAndSquaresForm.vue');
    const MultiplicationAndDivisionMathMagic = () =>
        import('../games/games-forms/MultiplicationAndDivisionMathMagicForm.vue');
    const TabularMultiplication = () => import('../games/games-forms/TabularMultiplicationForm.vue');
    const MemoryX = () => import('../games/games-forms/MemoryXForm.vue');
    const AssembleTheNumber = () => import('../games/games-forms/AssembleTheNumberForm.vue');
    const Loner = () => import('../games/games-forms/LonerForm');
    const LonerBonusGames = () => import('../games/games-forms/LonerBonusGamesForm');
    const SequenceOfNumbers = () => import('../games/games-forms/SequenceOfNumbersForm.vue');
    const Memo = () => import('../games/games-forms/MemoForm.vue');
    const MemoBonusGames = () => import('../games/games-forms/MemoForm.vue');
    const RevivedNumbers = () => import('../games/games-forms/RevivedNumbersForm.vue');
    const Associations = () => import('../games/games-forms/AssociationsForm.vue');
    const WhoIsWho = () => import('../games/games-forms/WhoIsWhoForm.vue');
    const SecretsOfCicero = () => import('../games/games-forms/SecretsOfCiceroForm.vue');
    const VocabularyWords = () => import('../games/games-forms/VocabularyWordsForm.vue');
    const VocabularyMemo = () => import('../games/games-forms/VocabularyMemoForm.vue');
    const CosmoTour = () => import('../games/games-forms/CosmoTourForm.vue');
    const MentalDrawing = () => import('../games/games-forms/MentalDrawingForm.vue');
    const HandsUp = () => import('../games/games-forms/HandsUpForm.vue');
    const Chameleon = () => import('../games/games-forms/ChameleonForm.vue');
    const RepeatAfterMe = () => import('../games/games-forms/RepeatAfterMeForm.vue');
    const CorrectiveSamples = () => import('../games/games-forms/CorrectiveSamplesForm.vue');
    const ChainsBonusGame = () => import('../games/games-forms/ChainsBonusGameForm.vue');
    const Scout = () => import('../games/games-forms/ScoutForm.vue');
    const Diada = () => import('../games/games-forms/DiadaForm.vue');
    const Alpari = () => import('../games/games-forms/AlpariForm.vue');
    const ChainsReadingEn = () => import('../games/games-forms/ChainsReadingEnForm.vue');
    const CouplesReadingEn = () => import('../games/games-forms/CouplesReadingEnForm.vue');
    const DivideItRight = () => import('../games/games-forms/DivideItRightForm.vue');
    const DivideUnstressedVowels = () => import('../games/games-forms/DivideUnstressedVowelsForm.vue');
    const WordStructure = () => import('../games/games-forms/WordStructureForm.vue');
    const SentenceParsing = () => import('../games/games-forms/SentenceParsingForm.vue');
    const VocabularyWordsRus = () => import('../games/games-forms/VocabularyWordsRusForm.vue');
    const PartsOfSpeech = () => import('../games/games-forms/PartsOfSpeechForm.vue');
    const ParsingSentencePartsSpeech = () => import('../games/games-forms/ParsingSentencePartsSpeechForm.vue');
    const SortOneMany = () => import('../games/games-forms/SortOneManyForm.vue');
    const GenericWords = () => import('../games/games-forms/GenericWordsForm.vue');
    const VerbTenses = () => import('../games/games-forms/VerbTensesForm.vue');
    const VocabularyMemoRus = () => import('../games/games-forms/VocabularyMemoRusForm.vue');
    const WordDrum = () => import('../games/games-forms/WordDrumForm.vue');
    const ChooseItRight = () => import('../games/games-forms/ChooseItRightForm.vue');
    const LettersSoundsSyllables = () => import('../games/games-forms/LettersSoundsSyllablesForm.vue');
    const TransferSyllables = () => import('../games/games-forms/TransferSyllablesForm.vue');
    const TransferSyllablesSchoolPreparing = () => import('../games/games-forms/TransferSyllablesSchoolPreparingForm.vue');
    const HardSoftConsonants = () => import('../games/games-forms/HardSoftConsonantsForm.vue');
    const HardSoftConsonantsSchoolPreparing = () => import('../games/games-forms/HardSoftConsonantsSchoolPreparingForm.vue');
    const Orthograph = () => import('../games/games-forms/OrthographForm.vue');
    const TranscriptionInWord = () => import('../games/games-forms/TranscriptionInWordForm.vue');
    const VoicedAndDeafConsonants = () => import('../games/games-forms/VoicedAndDeafConsonantsForm.vue');
    const PunctuationMarks = () => import('../games/games-forms/PunctuationMarksForm.vue');
    const Alphabet = () => import('../games/games-forms/AlphabetForm.vue');
    const ConnectThePuzzles = () => import('../games/games-forms/ConnectThePuzzlesForm.vue');

    import GradeApi from '../../api/grade';
    import { mapState } from 'vuex';
    import getGameName from '../../utils/trainer/trainer';
    import getType from '../../utils/trainer/getType';
    import comparingTrainersParameters from '../../utils/trainer/comparingTrainersParameters';
    import BillingBlockMixin from '../../utils/user/BillingBlockMixin';
    import FormTabs from '../games/shared/FormTabs';

    const MULTIPLAYER_GAMES = [
        'AdditionAndSubtractionWithTime',
        'AdditionAndSubtractionMathMagic',
        'MultiplicationAndDivision',
        'InteractiveFlashCards',
        'AdditionAndSubtraction',
        'Anzan',
        'AnzanWithTime',
        'Equation',
        'Factorization',
        'EquationMultiplication',
        'RootsAndDegrees',
        'MultiplicationAndDivisionMathMagic',
        'TabularMultiplication',
        'Loner',
        'LonerBonusGames',
        'RootsAndSquares',
    ];

    const BONUS_GAMES = ['MentalDrawing', 'HandsUp', 'Chameleon', 'RepeatAfterMe', 'CorrectiveSamples'];

    export default {
        props: {
            gameMode: {
                type: String,
                default: 'free-game',
            },
            id: [Number, String],
            gameId: [Number, String],
            gamesType: [String],
        },
        data() {
            return {
                gamesParameters: null,
                isLoading: false,
                playersNumber: 1,
                currentPlayer: 1,
                trainerGamesFromAllCourses: [],
                namesArray: [],
                sameSettings: false,
                sameSettingsAreActive: false,
            };
        },
        mixins: [getType, getGameName, comparingTrainersParameters, BillingBlockMixin],
        components: {
            ConnectThePuzzles,
            ChainsBonusGame,
            EquationMultiplication,
            CorrectiveSamples,
            Chameleon,
            RepeatAfterMe,
            MentalDrawing,
            HandsUp,
            AdditionAndSubtraction,
            FlashCards,
            MultiplicationAndDivision,
            MultiplicationAndDivisionCourse,
            MultiplicationAndDivisionMathMagic,
            TabularMultiplication,
            MemoryX,
            SequenceOfNumbers,
            AssembleTheNumber,
            Loner,
            LonerBonusGames,
            Equation,
            Factorization,
            TransferSyllables,
            TransferSyllablesSchoolPreparing,
            HardSoftConsonants,
            HardSoftConsonantsSchoolPreparing,
            Orthograph,
            TranscriptionInWord,
            VoicedAndDeafConsonants,
            Alphabet,
            DivideItRight,
            DivideUnstressedVowels,
            WordStructure,
            SentenceParsing,
            VocabularyWordsRus,
            PartsOfSpeech,
            ParsingSentencePartsSpeech,
            SortOneMany,
            GenericWords,
            VerbTenses,
            VocabularyMemoRus,
            WordDrum,
            ChooseItRight,
            EquationOnline,
            Anzan,
            Puzzle,
            Couples,
            Chains,
            Schulte,
            Scanner,
            WordsField,
            WordsFieldReadingEn,
            Expressions,
            Shutter,
            ShutterReadingEn,
            ShutterRussianLanguage,
            Anagrams,
            Texts,
            LettersField,
            CatchWord,
            CatchWordReadingEn,
            VisionField,
            VisionFieldReadingEn,
            Navigator,
            NavigatorBonusGames,
            Matrix,
            Memorize,
            KeenEye,
            KeenEyeBonusGames,
            NumericalNetwork,
            Synonyms,
            SynonymsReadingEn,
            SynonymsRussianLanguage,
            AntonymsRussianLanguage,
            Presentations,
            Antonyms,
            Search,
            Classifications,
            SoundCouples,
            DigitCouples,
            FourthOne,
            Memory,
            FormTabs,
            RootsAndDegrees,
            DayOfWeek,
            RootsAndSquares,
            Memo,
            MemoBonusGames,
            RevivedNumbers,
            Associations,
            WhoIsWho,
            SecretsOfCicero,
            VocabularyWords,
            VocabularyMemo,
            CosmoTour,
            Scout,
            Diada,
            Alpari,
            ChainsReadingEn,
            CouplesReadingEn,
            LettersSoundsSyllables,
            PunctuationMarks,
        },
        beforeRouteEnter(to, from, next) {
            if (from.params.courseType) {
                to.params.gamesType = from.params.courseType;
            }
            next();
        },
        methods: {
            checkIfUserHasAccessToGamesPage() {
                const { hasLimitTariff, noPlaytimeLeft, adminCantAccess } = checkUserRouteAccess(
                    this.user,
                    this.$route.name
                );
                if (hasLimitTariff && noPlaytimeLeft) {
                    return this.$router.push({ name: 'user:playtime-ended' });
                }

                if (adminCantAccess) {
                    return this.$router.push({ name: '403' });
                }
            },
        },
        mounted() {
            this.checkIfUserHasAccessToGamesPage();
            this.gameMode === 'free-game' &&
                this.$route.query.courseSettings &&
                this.$route.query.generatorSettings &&
                this.$router.back();
            if (!this.$offline && (this.user.type === 'student' || this.user.type === 'olympiads-student')) {
                this.isLoading = true;
                this.gamesParameters = {};
                GradeApi.list()
                    .then(response => {
                        response.data.forEach(grade => {
                            grade.course.games.forEach(game => {
                                if (this.trainerGamesFromAllCourses) {
                                    this.trainerGamesFromAllCourses.push(game);
                                }
                            });
                        });
                        this.gamesForComparison = _.cloneDeep(this.trainerGamesFromAllCourses);
                        let gamesAfterComparison = _.cloneDeep(this.getGamesAfterComparison());
                        gamesAfterComparison.forEach(game => {
                            this.gamesParameters[game.slug] = game.parameters.default;
                        });
                        this.$store.dispatch('setGamesParameters', this.gamesParameters);
                        this.isLoading = false;
                    })
                    .catch(() => {
                        this.isLoading = false;
                    });
            }
        },
        beforeRouteLeave(to, from, next) {
            let gamesRoutesNames = ['create:game', 'game:edit'];
            if (
                this.$store.state.games.puzzle &&
                !((to.meta.type && to.meta.type === 'trainer') || gamesRoutesNames.includes(to.name))
            ) {
                this.$store.dispatch('setPuzzleGame', null);
                this.$store.dispatch('setGame', null);
            }
            if (
                !(from.query.slug === 'Puzzle' && gamesRoutesNames.includes(to.name)) &&
                !(gamesRoutesNames.includes(from.name) && gamesRoutesNames.includes(to.name))
            ) {
                this.$store.dispatch('setGamesParameters', null);
            }
            next();
        },
        watch: {
            sameSettings(val) {
                this.sameSettingsAreActive = val;
            },
        },
        computed: {
            ...mapState({
                user: state => state.auth.user,
            }),
            doesGameAllowMultiplayer() {
                return MULTIPLAYER_GAMES.includes(this.$route.query.slug);
            },
            isBonusGames() {
                return BONUS_GAMES.includes(this.$route.query.slug);
            },
        },
    };
</script>

<style lang="scss" scoped>
    .form-container {
        margin: 0;
        height: 100%;
        background-color: $x-color-white;
        border-radius: $border-radius-40;
        box-sizing: border-box;
        @include media($sm) {
            padding: 30px;
        }
    }

    .form-container__box {
        margin: 0;
        padding: 30px;
        height: 100%;
        background-color: $hsl-color-gray-98;
        border-radius: $border-radius-20;
        box-sizing: border-box;
        @include media($md) {
            padding: 30px;
        }
    }

    .neuro-games__container {
        @include media($md) {
            width: 95%;
        }
        @include media($lg) {
            width: 100%;
        }
    }

    .form-container__field {
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin-bottom: 20px;
        @include media($md) {
            padding: 0 2.5px;
            flex-direction: row;
            align-items: center;
        }
        @include media($lg) {
            padding: 0 10%;
        }
        @include media($xlg) {
            padding: 0 13%;
        }
    }

    .form-container__label {
        min-width: 0;
        font-size: 16px;
        line-height: 19px;
        margin-right: 20px;
        margin-bottom: 0.5rem;
        @include media($md) {
            width: 8em;
            margin-bottom: 0;
            text-align: right;
        }
        @include media($xlg) {
            max-width: none;
            min-width: 13em;
        }
    }

    .form-container__select {
        flex-grow: 5;
    }

    .form-container__player-block-divider_before-game-setting {
        margin: 20px 0;
    }

    .form-container__checkbox {
        margin-right: 16%;
    }

    .help-block {
        color: #888888 !important;
    }

    .checkbox-field {
        flex-direction: row;
        align-items: center;
        @media screen and (max-width: 991px) {
            justify-content: flex-start;
        }
    }

    .checkbox-label {
        width: 100% !important;
        @include media($sm) {
            width: auto !important;
        }
        @media screen and (min-width: 576px) and (max-width: 767px) {
            margin-right: 20px !important;
        }
        @include media($md) {
            width: 58% !important;
        }
        @include media($lg) {
            width: 45% !important;
        }
        @include media($xlg) {
            width: 46% !important;
        }
        @include media($xl) {
            width: 37% !important;
        }
    }
</style>
